import { connect } from 'react-redux';

import FeaturedCollectionsBucket from '../components/FeaturedCollectionsBucket';

import {
    clickOnOnlineCollection,
    clickOnTransitionOnlineCollection,
} from '../redux/content/actions';

const _mapStateToProps = ({ app, content, location }) => ({
    launchOnlineCollectionsFeed:
        app.featureFlags && app.featureFlags.launchOnlineCollectionsFeed,
    isFeLoading: app.loadingState && app.loadingState.isFeLoading,
    isBotRequest: app.isBotRequest,
    currentPlace: location.currentPlace,
    collections:
        content.editorialCollections && content.editorialCollections.entities,
});

const _mapDispatchToProps = {
    trackGAEventOnPageUnload: clickOnOnlineCollection,
    trackGAEvent: clickOnTransitionOnlineCollection,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(FeaturedCollectionsBucket);
